import { useTranslation } from "react-i18next";
import { Pressable } from "react-native";
import { Text } from "react-native-paper";
import { useAppTheme } from "../../useAppTheme";
import Box from "../Box";

type Props = {
	handleOpenSupport?: () => void;
	label: string;
	buttonText: string;
	disabled?: boolean;
	email: string;
};

const ContactSupport = ({
	handleOpenSupport,
	label,
	buttonText,
	disabled,
	email,
}: Props) => {
	const theme = useAppTheme();
	const { t } = useTranslation();

	const isEduEmail = email.endsWith(".edu");
	const instructionMessage = isEduEmail
		? t("auth.emailInstruction.edu")
		: t("auth.emailInstruction.default");

	return (
		<Box
			flexDirection="column"
			alignItems="center"
			justifyContent="center"
			paddingTop={16}
			gap={12}
		>
			<Box
				flexDirection="row"
				alignItems="center"
				justifyContent="center"
				gap={4}
			>
				<Text variant="bodyMedium">{label}</Text>
				<Pressable disabled={disabled} onPress={handleOpenSupport}>
					<Text
						variant="bodyMedium"
						style={{
							color: theme.colors.secondary,
						}}
					>
						{buttonText}
					</Text>
				</Pressable>
			</Box>
			<Text
				variant="bodySmall"
				style={{
					textAlign: "center",
					color: theme.colors.onSurfaceVariant,
				}}
			>
				{instructionMessage}
			</Text>
		</Box>
	);
};

export default ContactSupport;
